import { isElectron } from "@/config/electron";
import { isStandaloneApp } from '@/helpers/standalone';

export class Device {
    static get isElectron() {
        return isElectron();
    }
    static get isStandalone() {
        return isStandaloneApp();
    }
    static get isRetina() {
        return window.devicePixelRatio >= 2;
    }
    static get isIPad() {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    }
    /** Safari's major version, also for the other iOS browsers (all WebKit); 0 for any other browser. */
    static safariVersion(ua = navigator.userAgent) {
        const ios = / OS (\d+)_\d+(?:_\d+)? like Mac OS X/.exec(ua);
        if (ios) {
            return Number(ios[1]);
        }
        // macOS, and iPads that ask for the desktop site: "Version/14.1.2 Safari/605.1.15"
        const mac = /Version\/(\d+)[\d.]* (?:Mobile\/\S+ )?Safari\//.exec(ua);
        return mac && !/Chrome|Chromium|Android/.test(ua) ? Number(mac[1]) : 0;
    }
    static get isTouch() {
        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
    };

    /** Touch only: no pointer can hover, so a tooltip would only show after a tap. */
    static get isPureTouch() {
        return window.matchMedia('(any-hover: none)').matches;
    }

    static get isMobile() {
        if (isElectron()) return false;

        const userAgent = navigator.userAgent.toLowerCase();
        const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

        // Early return if no touch support
        if (!hasTouch) return false;

        // Check for explicit mobile indicators
        const mobileRegex = /android.*mobile|iphone|ipod|blackberry|iemobile|opera mini/i;
        if (mobileRegex.test(userAgent)) return true;

        // Check for tablets (including iPad)
        const tabletRegex = /ipad|android(?!.*mobile)|tablet/i;
        if (tabletRegex.test(userAgent)) return true;

        // Exclude Windows touch laptops/desktops
        const isWindows = /windows/i.test(userAgent);
        if (isWindows && window.screen.width > 1200) return false;

        // Use pointer media query as final check
        return window.matchMedia('(pointer: coarse)').matches;
    }

    static get displayMode() {
        if (isElectron()) {
            return 'electron';
        }
        if (isStandaloneApp()) {
            return 'standalone';
        }
        return 'browser';
    }
}